import React from 'react'
import { getHomemadeListByIndex, getDetailImgs } from './service'
import RenderItem from '../../../../component/item'
import './index.scss'
import { hbsBoolean, getImgUrl, i18n } from '../../../../common/util'
import { AppContext } from '../../../../config/context'

const DetailCacheMap = {}
const PageSize = 7

class HmList extends React.Component {
    constructor() {
        super(...arguments)
        this.state = {
            index: -1,
            list: [],
            current: [],
            hasMore: false,
            detailImgs: [],
            detail: {
                name: '',
                desc: '',
                tags: []
            },
            detailGoodsId: 0
        }
    }

    componentDidMount() {
        this.changeIndex(0)
    }

    clearDetail = () => {
        this.setState({
            detailImgs: [],
            detail: {
                name: '',
                desc: '',
                tags: []
            },
            detailGoodsId: 0
        })
    }

    changeIndex = index => {
        if (index === this.state.index) {
            return
        }
        this.setState({
            index
        })
        getHomemadeListByIndex(index).then(list => {
            const current = list.slice(0, PageSize)
            const hasMore = list.length > current.length
            this.setState({
                list,
                current,
                hasMore
            })
            if (current.length) {
                this.showProductDetail(current[0])
            } else {
                this.clearDetail()
            }
        })
    }

    showProductDetail = item => {
        const { goodsId } = item
        if (goodsId === this.state.detailGoodsId) {
            return
        }
        const { name, desc, tags } = item
        this.setState({
            detail: {
                name,
                desc,
                tags
            },
            detailGoodsId: goodsId
        })
        const detailImgs = DetailCacheMap[goodsId]
        if (detailImgs) {
            return this.setState({
                detailImgs
            })
        }
        getDetailImgs(goodsId).then(dis => {
            DetailCacheMap[goodsId] = dis
            this.setState({
                detailImgs: dis
            })
        })
    }

    loadMore = () => {
        const { list, current } = this.state
        const newCurrent = list.slice(0, current.length + PageSize)
        this.setState({
            current: newCurrent,
            hasMore: list.length > newCurrent.length
        })
    }

    render() {
        const { index, current, hasMore, detail, detailImgs } = this.state
        const { lang } = this.context.user
        return <div>
            <ul className="homemade-sec-header">
                <li className={index === 0 ? 'homemade-sec-cate active' : 'homemade-sec-cate'} onClick={() => this.changeIndex(0)}>{i18n('热销', lang)}</li>
                <li className={index === 1 ? 'homemade-sec-cate active' : 'homemade-sec-cate'} onClick={() => this.changeIndex(1)}>{i18n('新品', lang)}</li>
                {/* <li className={index === 2 ? 'homemade-sec-cate active' : 'homemade-sec-cate'} onClick={() => this.changeIndex(2)}>{i18n('预售', lang)}</li> */}
                <li className={index === 3 ? 'homemade-sec-cate active' : 'homemade-sec-cate'} onClick={() => this.changeIndex(3)}>{i18n('折扣', lang)}</li>
            </ul>
            <div className="homemade-list-wrapper">
                <div className="homemade-detail-wrapper">
                    <div className="homemade-detail-window">
                        <div className="homemade-detail-content">
                            <p className="detail-name">{i18n(detail.name, lang)}</p>
                            <p className="detail-desc">{i18n(detail.desc, lang)}</p>
                            {
                                hbsBoolean(detail.tags) && <ul className="detail-tags">
                                    {
                                        detail.tags.map(tag => (<li className="detail-tag" key={tag.tagId}>{i18n(tag.name, lang)}</li>))
                                    }
                                </ul>
                            }
                            {
                                hbsBoolean(detailImgs) && <ul>
                                    {
                                        detailImgs.map((imgUrl, i) => (<li className="detail-img-li" key={i}>
                                            <img alt="" className="detail-img" src={getImgUrl(imgUrl)}></img>
                                        </li>))
                                    }
                                </ul>
                            }
                        </div>
                    </div>
                </div>
                <ul>
                    {
                        current.map(item => RenderItem(item, lang, this.showProductDetail))
                    }
                </ul>
                {
                    hasMore && <div className="homemade-list-more" onClick={this.loadMore}>查看更多</div>
                }
            </div>
        </div>
    }
}

HmList.contextType = AppContext
export default HmList